// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3exPa","legacyBtn":"MutateMid_legacyBtn__3yoj5"};